import React from "react";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";

function SkeletonBox({ children, ...rest }) {
  const showSpinner = useSelector((state) => state.showSpinner.value);

  return (
    <React.Fragment>
      {showSpinner ? <Skeleton {...rest} /> : children}
    </React.Fragment>
  );
}

export default SkeletonBox;
